module.exports = "<dofbasen-header></dofbasen-header>\n<div class=\"container-fluid\">\n    <router-outlet></router-outlet>\n</div>"


//////////////////
// WEBPACK FOOTER
// /Users/Anders/workspace/DOFBasenCli/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = main